import { paths } from "../../routes/paths";

/**
 * `module|entityType` -> where clicking that notification should land.
 *
 * The mirror of `_kNotificationRoutePrefixes` in the Flutter client's
 * notification_centre_screen.dart, resolved against THIS app's own routes - the
 * two clients receive identical rows from one server, so any pair the server can
 * emit has to be answered here as well or the notification arrives and clicking
 * it does nothing.
 *
 * `module` alone is not enough: Petty Cash raises approvals for three different
 * sub-entities, which is exactly why the server carries `entityType` as its own
 * field.
 *
 * Two shapes:
 *  - `detail(guid)` for anything this app can open by RecordGuid.
 *  - `page` for a module whose web screen is a worklist rather than a per-record
 *    route (vehicle requests are approved from a list here, unlike the mobile
 *    app's own request detail screen) - landing on the list is still far better
 *    than a dead click.
 */
const ROUTES = {
  "STOCK|lpos": { detail: paths.stockLpoDetail },
  // Complaint logged (managers/admin) and work assigned (the technician) both
  // point at the same work detail.
  "TECHNICAL|work": { detail: paths.technicalWorkDetail },
  "PETTYCASH|vouchers": { detail: paths.pettyCashVoucherDetail },
  "PETTYCASH|refills": { detail: paths.pettyCashRefillDetail },
  "PETTYCASH|reconciliations": { detail: paths.pettyCashReconciliationDetail },
  "SALES|enquiries": { detail: paths.salesEnquiryDetail },
  "QUOTATION|quotations": { detail: paths.quotationDetail },
  // No per-request route on the web - Pending Vehicle Requests is the screen
  // where these are actioned.
  "VEHICLES|requests": { page: paths.stockLpoPendingVehicleRequests },
  // Fuel refill approval / decision (2026-10-28) - refills are decided from the list.
  "FUEL|refills": { page: paths.fuelRefills },
  // A mobile unit reported back (control room); dispatch/cancel go to the car's app.
  "ALARMS|response": { detail: paths.alarmResponseDetail },
};

/** The path to open for a notification, or null when this app has nowhere to go. */
export const detailPathFor = (item) => {
  const route = ROUTES[`${item?.module}|${item?.entityType}`];
  if (!route) return null;
  if (route.page) return route.page;
  return item?.entityRecordGuid ? route.detail(item.entityRecordGuid) : null;
};

export default detailPathFor;
